// extracted by mini-css-extract-plugin
export default {"ScheduleWrapper":"ScheduleTabs_ScheduleWrapper__+6DFi","addBtn":"ScheduleTabs_addBtn__p60oT"};